import type { TFunction } from "i18next";
import type { ConfirmContextValue } from "../shell/emailBuilderConfirmTypes";
import { groupDeleteConfirmOptions } from "./confirmDelete";
import { findGroup } from "../domain/find";
import { getSelectionCapabilities } from "../domain/selection/policy";
import type { EmailDocument, Selection } from "../domain/types";

type DeleteSelectionActions = {
  deleteSelected: () => void;
  deleteGroup: (groupId: string, mode: "delete" | "ungroup") => void;
};

export async function deleteSelectionWithConfirm(
  document: EmailDocument,
  selection: Selection,
  { confirm }: Pick<ConfirmContextValue, "confirm">,
  actions: DeleteSelectionActions,
  t: TFunction,
): Promise<void> {
  if (selection.kind === "group") {
    const group = findGroup(document.sections, selection.groupId);
    if (!group) {
      return;
    }
    const confirmed = await confirm(groupDeleteConfirmOptions(t));
    if (confirmed) {
      actions.deleteGroup(selection.groupId, "delete");
    }
    return;
  }

  const capabilities = getSelectionCapabilities(document, selection);
  if (!capabilities?.canDelete) {
    return;
  }
  actions.deleteSelected();
}
